import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import Live from "./components/Live";
import Timeline from "./components/Timeline";
import Scene from "./components/Scene";
import Trust from "./components/Trust";
import Cta from "./components/Cta";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Masthead />
      <main>
        <Hero />
        <Live />
        <Timeline />
        <Scene />
        <Trust />
        <Cta />
      </main>
      <SiteFooter />
    </div>
  );
}